import React from 'react';

const Privacy = () => {
  const lastUpdated = '25 Ekim 2025';

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="bg-gray-50 py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Gizlilik Politikası
            </h1>
            <p className="text-lg text-gray-600">
              Son Güncelleme: {lastUpdated}
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto prose prose-lg">
            {/* Giriş */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              1. Giriş
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              ContractCode ("biz", "bizim" veya "şirket") olarak, gizliliğinize
              saygı duyuyoruz ve kişisel bilgilerinizi korumaya kararlıyız. Bu
              Gizlilik Politikası, contractcode.com.tr web sitesini ("Site")
              ziyaret ettiğinizde ve hizmetlerimizi kullandığınızda kişisel
              bilgilerinizi nasıl topladığımızı, kullandığımızı, paylaştığımızı
              ve koruduğumuzu açıklar.
            </p>

            {/* Toplanan Bilgiler */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              2. Toplanan Bilgiler
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Hizmetlerimizi kullandığınızda aşağıdaki bilgileri
              toplayabiliriz:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-6">
              <li>
                <strong>Kimlik Bilgileri:</strong> Ad, soyad, e-posta adresi,
                telefon numarası
              </li>
              <li>
                <strong>Şirket Bilgileri:</strong> Şirket adı, vergi numarası,
                adres
              </li>
              <li>
                <strong>Kullanım Bilgileri:</strong> IP adresi, tarayıcı türü,
                işletim sistemi, ziyaret edilen sayfalar
              </li>
              <li>
                <strong>Ödeme Bilgileri:</strong> Kredi kartı bilgileri (güvenli
                ödeme sistemleri üzerinden işlenir)
              </li>
              <li>
                <strong>İçerik Bilgileri:</strong> Oluşturduğunuz belgeler ve
                içerikler
              </li>
            </ul>

            {/* Bilgilerin Kullanımı */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              3. Bilgilerin Kullanımı
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Topladığımız bilgileri aşağıdaki amaçlarla kullanırız:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-6">
              <li>Hizmetlerimizi sağlamak ve iyileştirmek</li>
              <li>Hesabınızı oluşturmak ve yönetmek</li>
              <li>Ödemeleri işlemek ve faturaları düzenlemek</li>
              <li>Müşteri desteği sağlamak</li>
              <li>Size önemli güncellemeler ve bildirimler göndermek</li>
              <li>Yasal yükümlülüklerimizi yerine getirmek</li>
              <li>Platformumuzu güvenli tutmak ve dolandırıcılığı önlemek</li>
            </ul>

            {/* Çerezler */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              4. Çerezler ve Benzer Teknolojiler
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Sitemiz, kullanıcı deneyimini iyileştirmek ve site kullanımını
              analiz etmek için çerezler ve benzer teknolojiler kullanır.
              Çerezler, cihazınızda saklanan küçük metin dosyalarıdır.
              Tarayıcınızın ayarlarından çerezleri yönetebilir veya
              reddedebilirsiniz, ancak bu durumda bazı site özellikleri düzgün
              çalışmayabilir.
            </p>

            {/* Üçüncü Taraflar */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              5. Üçüncü Taraflarla Paylaşım
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Kişisel bilgilerinizi aşağıdaki durumlarda üçüncü taraflarla
              paylaşabiliriz:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-6">
              <li>
                <strong>Hizmet Sağlayıcılar:</strong> Ödeme işleme, e-posta
                hizmetleri, hosting gibi hizmetler için
              </li>
              <li>
                <strong>Yasal Gereklilikler:</strong> Yasal yükümlülüklerimizi
                yerine getirmek için
              </li>
              <li>
                <strong>İş Transferleri:</strong> Birleşme, satın alma veya varlık
                satışı durumunda
              </li>
              <li>
                <strong>Rızanızla:</strong> Açık rızanızı aldığımız diğer
                durumlar
              </li>
            </ul>

            {/* Veri Güvenliği */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              6. Veri Güvenliği
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Kişisel bilgilerinizi korumak için endüstri standardı güvenlik
              önlemleri kullanıyoruz. Bunlar arasında şifreleme, güvenlik
              duvarları, güvenli sunucular ve erişim kontrolleri bulunur. Ancak,
              internet üzerinden hiçbir veri iletimi tamamen güvenli değildir ve
              %100 güvenlik garantisi veremeyiz.
            </p>

            {/* Veri Saklama */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              7. Veri Saklama Süresi
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Kişisel bilgilerinizi, toplandıkları amaçlar için gerekli olduğu
              sürece veya yasal yükümlülüklerimiz gerektirdiği sürece
              saklarız. Hesabınızı sildiğinizde, kişisel bilgileriniz yasal
              saklama gereklilikleri hariç olmak üzere güvenli bir şekilde
              silinir.
            </p>

            {/* Haklarınız */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              8. Haklarınız
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              KVKK ve ilgili mevzuat kapsamında aşağıdaki haklara sahipsiniz:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-relaxed mb-6">
              <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
              <li>İşlenmişse buna ilişkin bilgi talep etme</li>
              <li>İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme</li>
              <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme</li>
              <li>Eksik veya yanlış işlenmişse düzeltilmesini isteme</li>
              <li>Silinmesini veya yok edilmesini isteme</li>
              <li>Düzeltme ve silme işlemlerinin aktarıldığı üçüncü kişilere bildirilmesini isteme</li>
              <li>Otomatik sistemler ile analiz edilmesi sonucu aleyhinize bir sonuç doğmasına itiraz etme</li>
              <li>Kanuna aykırı işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme</li>
            </ul>

            {/* Çocukların Gizliliği */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              9. Çocukların Gizliliği
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Hizmetlerimiz 18 yaşın altındaki çocuklara yönelik değildir. Bilerek
              18 yaşın altındaki çocuklardan kişisel bilgi toplamayız. Bir
              ebeveyn veya vasi iseniz ve çocuğunuzun bize kişisel bilgi
              sağladığını düşünüyorsanız, lütfen bizimle iletişime geçin.
            </p>

            {/* Değişiklikler */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              10. Gizlilik Politikası Değişiklikleri
            </h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Bu Gizlilik Politikasını zaman zaman güncelleyebiliriz.
              Değişiklikler bu sayfada yayınlanacak ve önemli değişiklikler için
              size e-posta ile bildirim gönderilebilir. Bu politikayı düzenli
              olarak gözden geçirmenizi öneririz.
            </p>

            {/* İletişim */}
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">
              11. İletişim
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Bu Gizlilik Politikası veya kişisel bilgilerinizle ilgili sorularınız
              için bizimle iletişime geçebilirsiniz:
            </p>
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 mb-6">
              <p className="text-gray-900 font-semibold mb-2">ContractCode</p>
              <p className="text-gray-700 mb-1">
                E-posta: privacy@contractcode.com.tr
              </p>
              <p className="text-gray-700 mb-1">
                Telefon: +90 (312) 123 45 67
              </p>
              <p className="text-gray-700">
                Adres: Örnek Mahallesi, Teknoloji Caddesi No: 123, Çankaya,
                Ankara 06000
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

Privacy.propTypes = {};

export default Privacy;

